import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutAlphaDental from "./sections/AboutAlphaDental";
import OurServicesOverview from "./sections/OurServicesOverview";
import ScheduleAnAppointment from "./sections/ScheduleAnAppointment";
import AppointmentSchedulingForm from "./sections/AppointmentSchedulingForm";
import ContactInformation from "./sections/ContactInformation";
import GoogleMapSection from "./sections/GoogleMapSection";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutAlphaDental />
      <OurServicesOverview />
      <ScheduleAnAppointment />
      <AppointmentSchedulingForm />
      <ContactInformation />
      <GoogleMapSection />
      <Footer />
    </div>;
}